/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Compare_WorkflowInputs */

const en_gc_resources_compare_workflow = /** @type {(inputs: Gc_Resources_Compare_WorkflowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typical workflow`)
};

const zh_gc_resources_compare_workflow = /** @type {(inputs: Gc_Resources_Compare_WorkflowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`典型工作流`)
};

/**
* | output |
* | --- |
* | "Typical workflow" |
*
* @param {Gc_Resources_Compare_WorkflowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_compare_workflow = /** @type {((inputs?: Gc_Resources_Compare_WorkflowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Compare_WorkflowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_compare_workflow(inputs)
	return zh_gc_resources_compare_workflow(inputs)
});
export { gc_resources_compare_workflow as "gc.resources.compare.workflow" }